import { ApplianceDetailsModelSerialFormValue } from '../../models/appliance-details-model-serial/appliance-details-model-serial-form-value.type';

export const mockApplianceDetailsModelSerialFormValue: ApplianceDetailsModelSerialFormValue =
  {
    modelNumber: '1234567890',
    serialNumber: 'ABC123',
  };
